import React, { ReactElement } from 'react';
import { useIntl } from 'react-intl';
import StaticPageComponent from '@fuww/library/src/StaticPage';
import { NavTabs } from '@fuww/library/src/Tabs';
import { useRouter } from 'next/router';
import Head from '../components/Head';
import Layout from '../components/Layout';
import messages from '../lib/messages.json';
import generateIntelligencePageBreadcrumbs
  from '../lib/generateIntelligencePageBreadcrumbs';
import Hero from '../components/Hero';
import redirectRouteToDomain from '../lib/redirectRouteToDomain';
import Tab from '../components/Tab';
import { MDXProvider } from '../components/mdxProvider';
import GlobalMDX
  from '../data/staticPages/global-fashion-industry-statistics/global.mdx';
import EuropeanUnionMDX
// eslint-disable-next-line max-len
  from '../data/staticPages/global-fashion-industry-statistics/european-union.mdx';
import FranceMDX
  from '../data/staticPages/global-fashion-industry-statistics/france.mdx';
import GermanyMDX
  from '../data/staticPages/global-fashion-industry-statistics/germany.mdx';
import SpainMDX
  from '../data/staticPages/global-fashion-industry-statistics/spain.mdx';
import ItalyMDX
  from '../data/staticPages/global-fashion-industry-statistics/italy.mdx';
import USAMDX
  from '../data/staticPages/global-fashion-industry-statistics/usa.mdx';

const headerImageUrls = {
  mobile: [
    'https://r.fashionunited.com/hg5_SDBh2Ha0SCFgZ1NgKz3fKSWNv5nFcVSwQU0ISKc/resize:fill:42:34:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvZmFzaGlvbl9pbmR1c3RyeV9zdGF0aXN0aWNzX2Jhbm5lcl9tb2JpbGUuanBn',
    'https://r.fashionunited.com/IN-jKrqj0umJlPhiFMc97zlk92h8el7rxUlbWLUsURU/resize:fill:360:288:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvZmFzaGlvbl9pbmR1c3RyeV9zdGF0aXN0aWNzX2Jhbm5lcl9tb2JpbGUuanBn',
    'https://r.fashionunited.com/hNwD_BAgpGzaYWp6Ch-A_t4Z0DtIg5d2HhjrSA3rS0g/resize:fill:720:576:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvZmFzaGlvbl9pbmR1c3RyeV9zdGF0aXN0aWNzX2Jhbm5lcl9tb2JpbGUuanBn',
  ],
  desktop: [
    'https://r.fashionunited.com/sFpbe6B9STvQvnH7_u0SiSZIwfhOsavIeMrBX_H1eyU/resize:fill:42:8:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvZmFzaGlvbl9pbmR1c3RyeV9zdGF0aXN0aWNzX2Jhbm5lcl9kZXNrdG9wLmpwZw',
    'https://r.fashionunited.com/2yWI2Mw3Qmc8nmSpwg7hDeBPUIuURInTaSykUjXbTR4/resize:fill:1350:277:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvZmFzaGlvbl9pbmR1c3RyeV9zdGF0aXN0aWNzX2Jhbm5lcl9kZXNrdG9wLmpwZw',
    'https://r.fashionunited.com/FuJMfaT4KX8t2qHCvoUyRBTEIMKMKovnAvUX0OGfVFA/resize:fill:2560:526:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvZmFzaGlvbl9pbmR1c3RyeV9zdGF0aXN0aWNzX2Jhbm5lcl9kZXNrdG9wLmpwZw',
    'https://r.fashionunited.com/nyFNHzlv7MmpKdVOTfrXIRgcgYw19L4qJme1ae2CdFc/resize:fill:5120:1052:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvZmFzaGlvbl9pbmR1c3RyeV9zdGF0aXN0aWNzX2Jhbm5lcl9kZXNrdG9wLmpwZw',
  ],
};

const regionOptions = [
  {
    route: 'global-fashion-industry-statistics',
    label: 'Global',
    value: 'global',
  },
  {
    route: 'global-fashion-industry-statistics',
    params: { region: 'european-union' },
    label: 'EU',
    value: 'european-union',
  },
  {
    route: 'global-fashion-industry-statistics',
    params: { region: 'france' },
    label: 'France',
    value: 'france',
  },
  {
    route: 'global-fashion-industry-statistics',
    params: { region: 'germany' },
    label: 'Germany',
    value: 'germany',
  },
  {
    route: 'global-fashion-industry-statistics',
    params: { region: 'spain' },
    label: 'Spain',
    value: 'spain',
  },
  {
    route: 'global-fashion-industry-statistics',
    params: { region: 'italy' },
    label: 'Italy',
    value: 'italy',
  },
  {
    route: 'global-fashion-industry-statistics',
    params: { region: 'usa' },
    label: 'USA',
    value: 'usa',
  },
];

const mdxComponents = {
  global: GlobalMDX,
  'european-union': EuropeanUnionMDX,
  france: FranceMDX,
  germany: GermanyMDX,
  spain: SpainMDX,
  italy: ItalyMDX,
  usa: USAMDX,
} as const;

const GlobalFashionIndustryStatisticsPage = () => {
  const intl = useIntl();
  const { query } = useRouter();
  const region = String(query.region ?? 'global');

  const breadcrumbs = generateIntelligencePageBreadcrumbs(
    intl,
    'global-fashion-industry-statistics',
    'globalFashionIndustryStatistics',
  );

  return (
    <>
      <Head
        title={intl.formatMessage(
          messages['globalFashionIndustryStatistics.title'],
        )}
        description={intl.formatMessage(
          messages['globalFashionIndustryStatistics.description'],
        )}
      />

      <StaticPageComponent
        breadcrumbs={breadcrumbs}
        content={(
          <>
            <NavTabs
              NavTab={Tab}
              value={region}
              tabs={regionOptions}
            />
            <MDXProvider>
              {
                React.createElement(
                  mdxComponents[region as keyof typeof mdxComponents],
                )
              }
            </MDXProvider>
          </>
        )}
        title={intl.formatMessage(
          messages['globalFashionIndustryStatistics.title'],
        )}
        subTitle={intl.formatMessage(
          messages['globalFashionIndustryStatistics.subTitle'],
        )}
        withTableStyles
      />
    </>
  );
};

GlobalFashionIndustryStatisticsPage.getLayout = (page: ReactElement) => (
  <Layout header={(
    <Hero
      imageUrls={headerImageUrls}
      alt="Global Fashion Industry Statistics"
    />
  )}
  >
    {page}
  </Layout>
);

GlobalFashionIndustryStatisticsPage.getInitialProps = redirectRouteToDomain(
  'global-fashion-industry-statistics',
);

export default GlobalFashionIndustryStatisticsPage;
